import React from 'react';
import MonthSelect from '../../../atoms/MonthSelect';
import GroupSelect, { groupItemSchema } from '~react/components/Calendar/components/GroupSelect';
import WeekSelect from '../../../atoms/WeekSelect';
import { z } from 'zod';

export const commonCellSchema = z.object({
    defaultValue: z.string(),
    label: z.string(),
    name: z.string(),
});
export const filterCellSchema = z.discriminatedUnion('type', [
    commonCellSchema.extend({
        type: z.literal('select'),
        options: z.array(groupItemSchema),
    }),
    commonCellSchema.extend({
        type: z.literal('week'),
        previousWeekLabel: z.string().default('Previous'),
        nextWeekLabel: z.string().default('Next'),
        currentWeekLabel: z.string().default('Current'),
    }),
    commonCellSchema.extend({
        type: z.literal('months'),
        from: z.string().optional(),
        to: z.string().optional(),
    }),
]);

type FilterCell = z.infer<typeof filterCellSchema>;

interface FilterProps {
    cells: FilterCell[];
    values: { [key: string]: string };
    onChange: (name: string, value: string) => void;
}

const Filter: React.FC<FilterProps> = props => {
    const cells = props.cells.map(cell => {
        switch (cell.type) {
            case 'week':
                return (
                    <WeekSelect
                        key={cell.name}
                        onChange={date => {
                            props.onChange(cell.name, date);
                        }}
                        value={'' === props.values[cell.name] ? undefined : props.values[cell.name]}
                        id={cell.name}
                        label={cell.label}
                        previousLabel={cell.previousWeekLabel}
                        nextLabel={cell.nextWeekLabel}
                        currentLabel={cell.currentWeekLabel}
                    />
                );
            case 'months':
                return (
                    <MonthSelect
                        key={cell.name}
                        onChange={date => {
                            props.onChange(cell.name, date);
                        }}
                        value={'' === props.values[cell.name] ? new Date() : new Date(props.values[cell.name])}
                        id={cell.name}
                        label={cell.label}
                        startDate={cell.from === undefined ? new Date() : new Date(Date.parse(cell.from))}
                        endDate={cell.to === undefined ? new Date() : new Date(Date.parse(cell.to))}
                    />
                );
            case 'select':
                return (
                    <GroupSelect
                        key={cell.name}
                        value={props.values[cell.name]}
                        setGroup={value => {
                            props.onChange(cell.name, value);
                        }}
                        label={cell.label}
                        show={true}
                        data={z.array(groupItemSchema).parse(cell.options)}
                        id={cell.name}
                    />
                );
        }
    });
    return <div className="filter -rounded">{cells}</div>;
};

export default Filter;
export { FilterCell };
